import UserEducationalStage from "./UserEducationalStage";
import UserEducationalStagesFilter from "./UserEducationalStagesFilter";

export default class UserEducationalStages {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.status = 0;
    this.msg = "";
    this.listSort = [];
    this.userEducationalStagesData = [];
    this.userEducationalStage = new UserEducationalStage();
    this.filterData = new UserEducationalStagesFilter();
  }
  fillData(data) {
    if (data) {
      this.status = data.status;
      this.msg = data.msg;
      this.listSort = data.listSort ?? [];
      let filter = { ...this.filterData, ...data.pagination };
      this.filterData.fillData(filter);
      this.userEducationalStagesData = data.userEducationalStagesData ?? [];
    } else {
      this.setInitialValue();
    }
  }
}
